var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeletePnc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33594 7.66667V12.6667M9.66927 7.66667V12.6667M1.33594 4.33333H14.6693M3.0026 4.33333V13.5C3.0026 14.8807 4.12189 16 5.5026 16H10.5026C11.8833 16 13.0026 14.8807 13.0026 13.5V4.33333H3.0026ZM10.5026 4.33333V2.66667C10.5026 1.74619 9.75641 1 8.83594 1H7.16927C6.2488 1 5.5026 1.74619 5.5026 2.66667V4.33333H10.5026Z",
    stroke: "#CE0202",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeletePnc);
export default __webpack_public_path__ + "static/media/deletePnc.62bd65a2772016499c81179ad1dbc603.svg";
export { ForwardRef as ReactComponent };